import * as React from 'react';
import { styled } from 'styled-components';
import { getQuestionSectionColour, Question } from './questionData';
import { slateGrey, superLightGreyColour } from '../../../cssConstants';
import ProgressLine from '../../common/ProgressLine';
import CircleLabel from '../../common/CircleLabel';
import { ProgressLineWrapper, ProgressStatus, ProgressStatusText } from '../../common/CardLayout';
import { SeparatorLine } from '../../common/Layout';
import { useQuestionsData } from '../../../../core/api';

const QuestionHeader = ({ questionId, sectionTitle, introduction }: Props) => {
	const questionsData = useQuestionsData() ?? [];
	const questionSectionColour = getQuestionSectionColour(sectionTitle);
	const totalCompletedQuestions = questionId ? getTotalCompletedQuestions(questionId, questionsData) : 0;
	const completedPercentage = (totalCompletedQuestions / 100) * 100;

	return (
		<>
			<LabelProgressLineWrapper>
				<StyledCircleLabel label="Progress" showCircle={false} color={slateGrey} />
				<ProgressStatus>
					<ProgressLineWrapper>
						<ProgressLine
							currentStep={totalCompletedQuestions}
							totalStep={100}
							color={questionSectionColour}
							height="8px"
						/>
					</ProgressLineWrapper>
					<ProgressStatusText>{completedPercentage.toFixed(0)}%</ProgressStatusText>
				</ProgressStatus>
			</LabelProgressLineWrapper>
			<HeaderTitle $color={questionSectionColour}>{sectionTitle}</HeaderTitle>
			<HeaderDescription>{introduction}</HeaderDescription>
			<SeparatorLine />
		</>
	);
};

export default QuestionHeader;

interface Props {
	questionId?: number;
	sectionTitle: string;
	introduction: string;
}

const getTotalCompletedQuestions = (questionId: number, questionsData: Question[]) => {
	const profilePageShare = 2;
	const completedShare =
		profilePageShare + Math.round(((questionId - 1) / questionsData.length) * (100 - profilePageShare));
	return completedShare;
};

const LabelProgressLineWrapper = styled.div`
	margin-top: -10px;
`;

const StyledCircleLabel = styled(CircleLabel)`
	font-size: 12px;
	font-weight: 500;
	line-height: 16px;
	letter-spacing: 0.5px;
`;

const HeaderTitle = styled.p<{ $color?: string }>`
	color: ${({ $color }) => $color || slateGrey};
	font-size: 16px;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: 0.15px;
	margin-top: 18px;
`;

const HeaderDescription = styled.p`
	color: ${superLightGreyColour};
	font-size: 14px;
	line-height: 20px;
	letter-spacing: 0.25px;
	margin: 10px 0 16px 0;
`;
